import api from './api'
import quick from './quick-pay'
import mocks from './mocks/index'

const sg = new api(process.env.VUE_APP_REG_URL)
Object.assign(sg, quick)

if (process.env.NODE_ENV !== 'production') {
    Object.assign(sg, mocks)
 }
 
export default sg